@if (showV3Composite) {
  <cure-plan-includes
    appTrackScrollDepth="regimen_value_prop"
    [bgColor]="planIncludesBgColor()"
    [headingText]="headingText()"
    [items]="planItems()"
    [interactive]="interactive() && !$any(this.regimenData())?.orderPlaced"
    [showMoneyback]="showMoneyBack()"
    [moneybackInteractive]="true"
    [moneyBackPercentText]="moneyBackPercentText()"
    [moneyBackTitleText]="moneyBackTitleText()"
    [moneyBackSubtitleText]="moneyBackSubtitleText()"
    [moneyBackActionText]="moneyBackActionText()"
    (curePress)="readMoreAboutServices()"
    (cureMoneybackPress)="onMoneyBackClick()">
  </cure-plan-includes>
} @else {
  <div appTrackScrollDepth="regimen_value_prop" [ngClass]="backgroundColor()" class="tw-pt-5 tw-pb-4 tw-font-normal" [attr.role]="interactive() ? 'button' : null" [attr.tabindex]="interactive() ? 0 : null" (click)="interactive() && readMoreAboutServices()" (keydown.enter)="interactive() && readMoreAboutServices()" (keydown.space)="interactive() && readMoreAboutServices()">
    <div class="tw-flex tw-items-center tw-justify-between tw-px-4 tw-pb-[14px]">
      <p class="tw-font-lexend tw-font-semibold tw-text-300 tw-text-gray-800"><span class="tw-capitalize">{{patientName()}}</span>, <span i18n="@@yourPlanIncludes">Your Plan includes</span></p>
      @if (interactive() && !$any(this.regimenData())?.orderPlaced) {
        <cs-icon class="tw-h-5 tw-w-5 tw-text-gray-900" [iconName]="'chevron_right'"></cs-icon>
      }
    </div>
    <div class="tw-flex tw-flex-col tw-gap-[6px] tw-tracking-none">
      @for (item of currentPlanInfo().items; track item.id; let i = $index) {
        <div class="tw-h-14 tw-flex tw-items-center tw-justify-between tw-font-lexend tw-text-300 tw-text-gray-800 tw-mx-4 tw-pl-4 tw-pr-2 tw-bg-white tw-rounded-2">
          <div class="tw-flex tw-items-center tw-gap-2 tw-tracking-normal">
            <cs-icon class="tw-w-4 tw-h-4 tw-text-green-500" [iconName]="'green_tick_circle'"></cs-icon>
            @if (item.id === planInfoItemId.PRODUCTS) {
              <span i18n="@@PRODUCT_TREATMENT_KIT_WITH_COUNT">{{ regimenProductsLength() }} product Treatment Kit</span>
            } @else {
              <p>{{item.title}}</p>
            }
          </div>
          <div class="tw-w-18 tw-h-full tw-flex tw-justify-center tw-items-center">
            <img [src]="getItemImage(item)" class="tw-object-contain tw-w-full tw-h-full" [alt]="item.id"/>
          </div>
        </div>
      }
    </div>
    @if (showBottomBadgeTexts()) {
      <div class="tw-flex tw-items-center tw-justify-center tw-font-body tw-text-200 tw-text-black tw-mt-2 tw-mx-4 tw-py-2 tw-px-[9px]">
        <p class="tw-w-[98px] tw-text-left" i18n="@@100%Effective">100% Effective</p>
        <div class="tw-flex-none tw-border-solid tw-border-l tw-border-gray-900 tw-opacity-20 tw-self-stretch"></div>
        <p class="tw-flex-1 tw-text-center" i18n="@@clinicallyTested">Clinically Tested</p>
        <div class="tw-flex-none tw-border-solid tw-border-l tw-border-gray-900 tw-opacity-20 tw-self-stretch"></div>
        <p class="tw-w-[90px] tw-text-right" i18n="@@freeDelivery">Free Delivery</p>
      </div>
    }
  </div>
}
